// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const centerContent = function (scrollpos, header, container, element) {
  let margin;
  if (scrollpos >= header) {
    const offset = scrollpos - header;
    const newHeight = container.height() - offset;
    margin = (newHeight - element.height()) / 2 + offset;
    return element.css({ 'margin-top': margin + 'px' });
  } else if (scrollpos < header) {
    margin = (container.height() - element.height()) / 2;
    return element.css({ 'margin-top': margin + 'px' });
  }
};

const setOpacity = function (scrollposition, height, element) {
  let opacity = 1.0;

  if (scrollposition <= height) {
    opacity = 1.0 - scrollposition / height;
    if (opacity < 0) {
      opacity = 0;
    }
  } else if (scrollposition > height) {
    opacity = 0;
  }

  return element.css({ opacity });
};

const zoomBackground = function (scrollpos, header, container) {
  // zooming at 10% velocity
  const zoomVelocity = 10.0;
  const zoom = zoomVelocity * (scrollpos / (container.height() + header)) + 100;
  return container.css({ 'background-size': zoom + '% ' + zoom + '%' });
};

$(window).bind('load resize scroll', function () {
  const headlineContainer = $('.headline-container');
  const headline = $('.headline-container .headline');
  const headlineContent = $('.headline-container .headline h1');
  const scrollpos = $(window).scrollTop();
  const header =
    $('.search-container').height() + $('#content-root-header').height();

  setOpacity(scrollpos, header + headlineContainer.height(), headlineContent);
  centerContent(scrollpos, header, headlineContainer, headlineContent);
  return zoomBackground(scrollpos, header, headlineContainer);
});
